

export default class NoRecentOrderDisplayBoard extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div>
                <div className="no-fav-menu-card-container hidesection">
                    <span>
                        {this.props.title}
                    </span>
                    <span>
                        {this.props.subTitle}
                    </span>
                </div>
            </div>
        );
    }
}
